import React from "react";

export default function Brand() {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Brand">
        <g id="Group">
          <path
            id="Vector"
            d="M331.895 160.645C330.667 157.993 328.011 156.294 325.088 156.294C322.165 156.294 319.509 157.992 318.281 160.645L299.507 201.221C295.441 210.01 309.069 216.276 313.12 207.52L313.7 206.266H336.474L337.054 207.52C338.793 211.279 343.25 212.917 347.01 211.177C350.769 209.438 352.406 204.98 350.667 201.221L331.895 160.645ZM320.642 191.265L325.089 181.655L329.535 191.265H320.642Z"
            fill="#242424"
          />
          <path
            id="Vector_2"
            d="M385.126 155.689H371.196C367.053 155.689 363.696 159.047 363.696 163.189V204.371C363.696 208.513 367.053 211.871 371.196 211.871H385.126C400.615 211.871 413.217 199.269 413.217 183.78C413.217 168.291 400.615 155.689 385.126 155.689ZM385.126 196.87H378.696V170.689H385.126C392.345 170.689 398.217 176.562 398.217 183.78C398.217 190.998 392.345 196.87 385.126 196.87Z"
            fill="#242424"
          />
          <path
            id="Vector_3"
            d="M441.655 80.077C441.655 75.935 438.298 72.577 434.155 72.577H51.9801C42.3061 72.577 42.3061 87.5769 51.9801 87.5769H434.155C438.298 87.5769 441.655 84.2189 441.655 80.077Z"
            fill="#242424"
          />
          <path
            id="Vector_4"
            d="M238.895 114.058H51.9801C42.3061 114.058 42.3061 129.058 51.9801 129.058H238.895C248.569 129.058 248.569 114.058 238.895 114.058V114.058Z"
            fill="#242424"
          />
          <path
            id="Vector_5"
            d="M238.894 155.539H51.9796C42.3056 155.539 42.3056 170.539 51.9796 170.539H238.894C248.568 170.539 248.568 155.539 238.894 155.539Z"
            fill="#242424"
          />
          <path
            id="Vector_6"
            d="M238.894 197.02H51.9796C42.3056 197.02 42.3056 212.019 51.9796 212.019H238.894C248.568 212.019 248.568 197.02 238.894 197.02Z"
            fill="#242424"
          />
          <path
            id="Vector_7"
            d="M238.894 238.5H51.9796C42.3056 238.5 42.3056 253.5 51.9796 253.5H238.894C248.568 253.5 248.568 238.5 238.894 238.5Z"
            fill="#242424"
          />
          <path
            id="Vector_8"
            d="M507.484 283.357L490.781 271.001V58.0947C490.781 35.1069 472.078 16.4041 449.09 16.4041H108.999C99.3252 16.4041 99.3252 31.4039 108.999 31.4039H449.09C463.808 31.4039 475.781 43.3778 475.781 58.0947V259.905L441.457 234.514C441.583 233.97 441.655 233.406 441.655 232.824V121.557C441.655 117.415 438.298 114.057 434.155 114.057H277.876C273.733 114.057 270.376 117.415 270.376 121.557V246C270.376 250.142 273.733 253.5 277.876 253.5H414.605V291.577H14.9999V58.0997C14.9999 43.3798 26.9758 31.4049 41.6947 31.4049H66.9995C76.6734 31.4049 76.6734 16.4051 66.9995 16.4051H41.6947C18.7049 16.4041 0 35.1089 0 58.0997V347.687C0 370.678 18.7049 389.382 41.6947 389.382H195.743V445.309H154.173C121.805 445.309 121.708 495.595 154.173 495.595H286.998C296.672 495.595 296.672 480.595 286.998 480.595H154.173C141.122 480.595 141.101 460.309 154.173 460.309H336.607C349.658 460.309 349.679 480.595 336.607 480.595H330.997C321.323 480.595 321.323 495.595 330.997 495.595H336.607C368.975 495.595 369.072 445.309 336.607 445.309H296.139V389.382H449.086C472.077 389.382 490.781 370.677 490.781 347.687V303.528H501.008C511.996 303.528 515.829 289.528 507.484 283.357V283.357ZM457.203 288.545C453.688 288.587 450.365 290.698 448.313 293.552L429.548 319.018V244.364L489.275 288.545H457.203ZM285.376 238.5V129.057H426.655V225.552C424.606 225.359 422.505 225.735 420.582 226.712C416.806 228.63 414.476 232.454 414.502 236.689L414.513 238.5H285.376ZM281.14 445.31H210.744V389.383H281.14V445.31ZM475.781 347.687C475.781 362.407 463.805 374.382 449.086 374.382H41.6947C26.9758 374.382 14.9999 362.407 14.9999 347.687V306.577H414.929V331.046C414.993 341.519 429.114 345.949 435.216 337.467L459.346 303.903H475.782V347.687H475.781Z"
            fill="#242424"
          />
        </g>
      </g>
    </svg>
  );
}
